import { render, staticRenderFns } from "./select_people.vue?vue&type=template&id=edefa89c&scoped=true&"
import script from "./select_people.vue?vue&type=script&lang=js&"
export * from "./select_people.vue?vue&type=script&lang=js&"
import style0 from "./select_people.vue?vue&type=style&index=0&id=edefa89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edefa89c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edefa89c')) {
      api.createRecord('edefa89c', component.options)
    } else {
      api.reload('edefa89c', component.options)
    }
    module.hot.accept("./select_people.vue?vue&type=template&id=edefa89c&scoped=true&", function () {
      api.rerender('edefa89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/job_summary/components/select_people.vue"
export default component.exports